/**
 * datePickerDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { isSameDay } from '@shared/utils/datetime';
import isFunction from 'lodash-es/isFunction';
import moment from 'moment';

/**
 * Shows an md-datepicker without the input field. Uses moment instances.
 */
export function datePickerDirective() {
    return {
        restrict: 'E',
        transclude: true,
        //language=HTML
        template: `
            <md-datepicker ng-model="_value"
                           ng-model-options="ngModelOptions"
                           ng-required="required"
                           ng-change="_onChange()"
                           ng-disabled="disabled"
                           md-date-filter="dateFilter"
                           form="form"
                           name="{{ name }}">
            </md-datepicker>

            <md-tooltip ng-if="tooltip">
                {{ tooltip }}
            </md-tooltip>
        `,
        scope: {
            change: '&?change',
            dateFilter: '=?dateFilter',
            disabled: '=ngDisabled',
            form: '=form',
            label: '@label',
            name: '@name',
            ngModelOptions: '=?ngModelOptions',
            tooltip: '@?tooltip',
            required: '=?required',
            value: '=value',
        },
        link: function(scope) {
            scope._value = undefined;

            scope._onChange = () => (isFunction(scope.change) ? scope.change() : null);

            scope.$watch('value', _valueWatcher, true);
            scope.$watch('_value', _internalValueWatcher, true);

            /**
             * @param {moment.Moment} value
             * @private
             */
            function _valueWatcher(value) {
                if (value) {
                    if (!isSameDay(value, scope._value)) {
                        scope._value = moment(value).toDate();
                    }
                } else {
                    scope._value = null;
                }
            }

            /**
             * @param {Date?} value
             * @private
             */
            function _internalValueWatcher(value) {
                if (value) {
                    if (!isSameDay(value, scope.value)) {
                        scope.value = moment(value);
                    }
                } else {
                    scope.value = null;
                }
            }
        },
    };
}
